import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getAIInsightsAdditionalReportContext } from 'reporting-data/report/reportGetters';
import { setAIInsightsAdditionalReportContext } from 'reporting-data/report/reportSetters';
import debounce from 'transmute/debounce';
import { useAIInsightsTracker } from '../useAIInsightsTracker';
import { CharacterCounter } from 'foundations-components/transitional/components/CharacterCounter';
import { jsx as _jsx } from "react/jsx-runtime";
export function AISettingsInstructions({
  report,
  onPreviewReportChange
}) {
  const [instructions, setInstructions] = useState(getAIInsightsAdditionalReportContext(report));
  const {
    trackAIInsightsEvent
  } = useAIInsightsTracker(report);
  const updateReport = useCallback(value => {
    const updatedReport = setAIInsightsAdditionalReportContext(report, value);
    onPreviewReportChange(updatedReport);
    trackAIInsightsEvent({
      action: 'additionalInstructionsUpdate'
    });
  }, [report, onPreviewReportChange, trackAIInsightsEvent]);
  const updatedReportDebounced = useMemo(() => debounce(300, updateReport), [updateReport]);
  const onInstructionsChange = useCallback(event => {
    const value = event.target.value;
    setInstructions(value);
    updatedReportDebounced(value);
  }, [updatedReportDebounced]);
  useEffect(() => {
    setInstructions(getAIInsightsAdditionalReportContext(report));
  }, [report]);
  return /*#__PURE__*/_jsx(CharacterCounter, {
    maxLength: 200,
    value: instructions,
    onChange: onInstructionsChange,
    inlineSize: "100%",
    renderInput: ({
      count,
      onChange,
      maxLength,
      value
    }) => /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text('reporting-enablement.aiInsightsSettings.instructions.title'),
      characterCount: count,
      paddingInline: "50",
      children: /*#__PURE__*/_jsx(TextArea, {
        blockSize: "200px",
        value: value,
        onChange: onChange,
        maxLength: maxLength
      })
    })
  });
}